import React, {useEffect} from 'react';
import useUserStore from "../../stores/store";
import {ConfigProvider, Spin} from "antd";


function CustomLoader ({customLoaderFlag = false}) {
    const { networkCall } = useUserStore();
    
    useEffect(()=>{
        if (networkCall || customLoaderFlag) {
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden'; // Prevent scroll
        } else {
            document.documentElement.style.overflow = '';
            document.body.style.overflow = ''; // Re-enable scroll once loading is done
        }
    },[networkCall, customLoaderFlag])
    return (
        <>
            {(networkCall || customLoaderFlag) && (<div className="fixed top-0 left-0 w-full h-full flex justify-center items-center z-[2000] bg-white bg-opacity-50">
                <div className="flex flex-col h-screen w-full justify-center">
                    <div className="flex flex-col">
                        <ConfigProvider
                            theme={{
                                components: {
                                    Spin: {
                                        dotSizeLG: 80,
                                        colorPrimary: '#572D86'
                                    },
                                },
                            }}
                        >
                            <Spin size="large" />
                        </ConfigProvider>
                    </div>
                </div>
            </div>)}
        </>
    );
}

export default CustomLoader;
